import React, { useState } from "react";
import NavBar from "./NavBar";
import HomePage from "./HomePage";
import LoginPage from "./LoginPage";
import DragDropCSV from "./DragDropCSV";
import ProfileTests from "./ProfileTests";
import Archives from "./archives";
import { positions, Provider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import ItemSelectionScreen from "./ItemSelectionScreen";
import STIReport from "./STI_REPORT";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import NavBarNew from "./NavBarNew";
import ProductConfig from "./ProductConfig";
import SampleReport from "./SampleReport";
import { ThemeProvider } from "@mui/material";
import { theme } from "../theme";
import Signup from "./Signup";
import ResetPassword from "./ResetPassword";
import ProtectedRoute from "./ProtectedRoute";
import Home from "./messaging/ChooseProfiles";
import Cohorts from "./messaging/Cohorts";
import ChooseProfiles from "./messaging/ChooseProfiles";
import Prompts from "./messaging/Prompts";

// react alert package configrurations
const options = {
  timeout: 3500,
  position: positions.BOTTOM_CENTER,
};

const App = () => {
  const [isLogged, setIsLogged] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <div className="">
        <Router>
          <Switch>
            <Provider className="mb-2" template={AlertTemplate} {...options}>
              <Route
                path="/login"
                render={(props) => (
                  <LoginPage {...props} setIsLogged={setIsLogged} />
                )}
                exact
              />
              <Route path="/signup" component={Signup} exact />
              <Route path="/reset-password" component={ResetPassword} exact />

              <ProtectedRoute
                path="/Manual-Entry-Home-Page"
                component={HomePage}
                isLogged={isLogged}
                exact
              />
              <ProtectedRoute
                path="/"
                component={SampleReport}
                isLogged={isLogged}
                exact
              />

              <ProtectedRoute
                path="/itemSelection"
                component={ItemSelectionScreen}
                isLogged={isLogged}
                exact
              />
              <ProtectedRoute
                path="/profileTests"
                component={ProfileTests}
                isLogged={isLogged}
                exact
              />
              {/* <Route path="/Manual-Entry-Home-Page" component={HomePage} exact />
            
            <Route path="/itemSelection" component={ItemSelectionScreen} exact />
            <Route path="/profileTests" component={ProfileTests} exact /> */}

              <ProtectedRoute
                path="/upload-file"
                component={DragDropCSV}
                isLogged={isLogged}
                exact
              />
              <Route path="/STI_Report" component={STIReport} exact />
              <Route path="/archives" component={Archives} exact />
              <Route path="/messaging" component={ChooseProfiles} exact />
              <Route path="/messaging-cohorts" component={Cohorts} exact />
              <Route path="/settings" component={Prompts} exact />
            </Provider>
          </Switch>
        </Router>
      </div>
    </ThemeProvider>
  );
};

export default App;
